import { useEffect } from 'react';
import { smoothScrollToTop } from '@/utils/smoothScrollToTop';
/**
 * Hook to scroll to top of the page when the price page props change
 *
 * @param pricePageProps
 */
export const useScrollToTop = (pricePageProps) => {
    useEffect(() => {
        if (!pricePageProps)
            return;
        smoothScrollToTop();
    }, [pricePageProps]);
};
